import i18n from 'services/base/i18n';

export default {
  // Link to edit this parental control rule
  edit: () => i18n.pgettext('Pages|View Parental Controls', 'EDIT'),
  // Header for the section that shows the time period and days of the week that this rule applies
  schedule: () => i18n.pgettext('Pages|View Parental Controls', 'SCHEDULE'),
  // Header for the section that lists the block list for this rule
  blockedApps: () => i18n.pgettext('Pages|View Parental Controls', 'BLOCKED SITES & APPS'),
  // Header for the section that lists the devices this rule applies to
  managedDevices: () => i18n.pgettext('Pages|View Parental Controls', 'MANAGED DEVICES'),
  // Button to delete this parental control rule
  deleteRule: () => i18n.pgettext('Pages|View Parental Controls', 'DELETE RULE'),
};
